<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          Previous History Information
        </h3>
        <div v-if="historyGaps.length > 0" class="gap-warning mt-4">
          <h4 class="text-danger">⚠ History Gaps Found</h4>
          <ul class="text-danger">
            <li v-for="(gap, index) in historyGaps" :key="index">
              Missing period: {{ dateFormatter(gap.start) }} to {{ dateFormatter(gap.end) }}
            </li>
          </ul>
        </div>
      </div>
      <template v-if="sortedCandidateHistory.length > 0">
          <div class="d-flex flex-wrap justify-content-between">
            <div v-for="(item, index) in sortedCandidateHistory" :key="index"  class="col-md-6 my-2">
              <div class="card-item">
                <div class="form-group row align-items-center">
                  <div class="col-6">
                    <template v-if="item.type === 0">
                      <label class="col-sm-12 mb-sm-1">{{ item.title }} | Employment</label>
                      <label class="col-sm-12 mb-sm-1">{{ item.company_name }}</label>
                      <label class="col-sm-12 mb-sm-1">{{item.start_date_formatted }} -
                        {{item.end_date_formatted }} | {{ item.company_address }}</label>
                      <label class="col-sm-12 mb-sm-1">{{ calculateDifference(item.end_date, item.start_date) }}</label>
                    </template>
                    <template v-if="item.type === 1">
                      <label class="col-sm-12 mb-sm-1">{{ item.qualification }} | Education</label>
                      <label class="col-sm-12 mb-sm-1">{{ item.institute }}</label>
                      <label class="col-sm-12 mb-sm-1">{{item.start_date_formatted }} -
                        {{item.end_date_formatted }} | {{ item.institute_address }}</label>
                      <label class="col-sm-12 mb-sm-1">{{ calculateDifference(item.end_date, item.start_date) }}</label>
                    </template>
                    <template v-if="item.type === 2">
                      <label class="col-sm-12 mb-sm-1">{{ item.name }} | Self-Employment / Trade</label>
                      <label class="col-sm-12 mb-sm-1">{{ item.utr_number }}</label>
                      <label class="col-sm-12 mb-sm-1">{{item.start_date_formatted }} -
                        {{item.end_date_formatted }} | {{ item.address }}</label>
                      <label class="col-sm-12 mb-sm-1">{{ calculateDifference(item.end_date, item.start_date) }}</label>
                    </template>
                    <template v-if="item.type === 3">
                      <label class="col-sm-12 mb-sm-1">Unemployed</label>
                      <label class="col-sm-12 mb-sm-1">
                        {{item.start_date_formatted }} - {{item.end_date_formatted }}
                      </label>
                      <label class="col-sm-12 mb-sm-1">{{ calculateDifference(item.end_date, item.start_date) }}</label>
                    </template>
                  </div>


                  <div class="col-6" v-if="isAdmin">
                    <div v-if="item.screening_endorsement">
                      Endorsements
                      <p><strong>Requested At:</strong> {{ item.screening_endorsement.requested_at }}</p>
                      <p v-if="item.screening_endorsement.endorsed_at">
                        <strong>Endorsed At:</strong> {{ item.screening_endorsement.endorsed_at }}
                      </p>
                      <p>
                        <strong>Status:</strong>
                        <a
                            :href="statusLinks[item.screening_endorsement.id] || '#'"
                            target="_blank"
                            rel="noopener noreferrer"
                            @click.prevent="fetchStatus(item.screening_endorsement.id)"
                        >
                          {{ item.screening_endorsement.status || 'Loading...' }}
                        </a>
                      </p>
                    </div>
                    <div v-if="getLatestStatus(item)"
                        :class="getHighlightClass(getLatestStatus(item))"
                        :style="getHighlightStyle(getLatestStatus(item))"
                    >
                      {{ getStatusValue(getLatestStatus(item)) }}
                    </div>

                    <div v-if="!getLatestStatus(item)"
                         class="highlight-orange"
                    >Verification Pending
                    </div>

                  </div>

                  <div class="col-6">
                    <div
                        v-if="!isAdmin && isRevertToApplicant(getLatestStatus(item))"
                        class="highlight-orange"
                    >To do: {{  getStatusComment(getLatestStatus(item)) }}
                    </div>
                  </div>


                  <div class="col-sm-12 mt-sm-3 d-flex flex-wrap">
                    <el-button class="btn btn-danger el-button--default float-right"
                               @click="updateBtnHandler(item.id, item.type)">
                      Update
                    </el-button>
                    <el-button class="btn btn-danger el-button--default float-right mr-sm-2"
                               @click="removeBtnHandler(item.id, item.type)">
                      Remove
                    </el-button>
                    <div class="float-right mr-sm-2" v-if="isAdmin">
                      <drawer-component title="Action History" size="70%" btnText="Take Action">
                        <history-comments
                            :comment="item.screening_status"
                            :applicantId="candidateId"
                            :statusable_type="item.statusable_type"
                            :statusable_id="item.id"
                            :candidate="item"
                            :emailAddress="emailAddress"
                        />
                      </drawer-component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>
      <div class="form-group row align-items-center">
        <app-input class="col-sm-12 mb-sm-4"
                   type="radio"
                   :list="employmentTypeList"
                   v-model="employment_type"/>
      </div>
        <template v-if="employment_type === historyType.Employment">
          <div class="row">

            <div class="form-group mb-3 col-md-6 align-items-center">
              <label class="col-sm-12 mb-sm-2">Provide previous employment details. Do you have p45 or p46</label>
              <app-input class="col-sm-12"
                         type="radio"
                         :list="employmentDetailsTypeList"
                         v-model="employment.is_have_p45_or_p46"
                         placeholder=""
              />
            </div>
            <template v-if="employment.is_have_p45_or_p46 === 'p45'">
              <div class="form-group mb-3 col-md-6 align-items-center">
                <label class="col-sm-12 mb-2">Attach a copy of P45</label>
                <app-input class="col-sm-12"
                           type="file"
                           v-on:change="documentp45Change"
                           :label="$t('upload_your_file')"
                           v-model="employment.copy_of_p45"
                           placeholder="attach copy"
                />
              </div>
            </template>
            <template v-if="employment.is_have_p45_or_p46 === 'p46'">
              <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
                <app-input class="col-sm-12 mb-sm-4"
                           type="radio"
                           :list="p46List"
                           v-model="employment.p46_detail"
                           placeholder=""
                />
              </div>
            </template>
          <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Job Title</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="employment.title"
                       placeholder=""
            />
          </div>
          <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Job Description</label>
            <app-input class="col-sm-12 mr-sm-2 mb-sm-2"
                       type="textarea"
                       v-model="employment.description"
                       placeholder=""
            />
            </div>
            <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Company Name</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="employment.company_name"
                       placeholder=""
            />
          </div>
            <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Address</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="employment.company_address"
                       placeholder=""
            />
            </div>
              <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Reason for Leaving</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="employment.reason_for_leaving"
                       placeholder=""
            />
              </div>
                <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Contact Name</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="employment.contact_name"
                       placeholder=""
            />
                </div>
                  <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Contact Number</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="tel-input-custom"
                       v-model="employment.contact_number"
                       placeholder=""
            />
                  </div>
                    <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Contact Email</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="email"
                       v-model="employment.contact_email"
                       placeholder=""
            />
                      </div>
                      <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
            <label class="col-sm-12 mb-sm-0">Employment Start Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="employment.start_date"
                       placeholder=""
            />
            <div class="error" v-if="!$v.employment.start_date.isValidFromDate">
              From Date Can't Be Greater Than To Date.
            </div>
                      </div>
          <div class="form-group mb-3 mt-3 col-md-6 align-items-center">

            <label class="col-sm-12 mb-sm-0">Employment End Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="employment.end_date"
                       placeholder=""
            />
                        </div>
          </div>
        </template>

      <template v-if="employment_type === historyType.Education">
          <div class="form-group row align-items-center ml-sm-2">
            <label class="col-sm-12 mb-sm-0">Qualification</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="education.qualification"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Institute</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="education.institute"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Award Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="education.award_date"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Course Length</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="education.course_length"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Contact Name</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="education.contact_name"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Contact Number</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="tel-input-custom"
                       v-model="education.contact_number"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Contact Email</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="email"
                       v-model="education.contact_email"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Institute Address</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="textarea"
                       v-model="education.institute_address"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">From</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="education.start_date"
                       placeholder=""
            />
            <div class="error" v-if="!$v.education.start_date.isValidFromDate">
              From Date Can't Be Greater Than To Date.
            </div>
            <label class="col-sm-12 mb-sm-0">To</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="education.end_date"
                       placeholder=""
            />
          </div>
        </template>
        <template v-if="employment_type === historyType.SelfEmploymentTrade">
          <div class="form-group row align-items-center ml-sm-2">
            <label class="col-sm-12 mb-sm-0">Trading Name / Business Name</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="selfEmployment.name"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">UTR / Company Number</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="selfEmployment.utr_number"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Trading / Business Details</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="textarea"
                       v-model="selfEmployment.details"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Trading / Business Address</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="selfEmployment.address"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Accountant Name</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="text"
                       v-model="selfEmployment.accountant_name"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Accounting Firm</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="textarea"
                       v-model="selfEmployment.accounting_firm"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Contact Number</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="tel-input-custom"
                       v-model="selfEmployment.contact_number"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Contact Email</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="email"
                       v-model="selfEmployment.contact_email"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">From</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="selfEmployment.start_date"
                       placeholder=""
            />
            <div class="error" v-if="!$v.selfEmployment.start_date.isValidFromDate">
              From Date Can't Be Greater Than To Date.
            </div>
            <label class="col-sm-12 mb-sm-0">To</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="selfEmployment.end_date"
                       placeholder=""
            />
          </div>
        </template>
        <template v-if="employment_type === historyType.Unemployed">
          <div class="form-group row align-items-center ml-sm-2">
            <label class="col-sm-12 mb-sm-0">Unemployment Start Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="unEmployment.start_date"
                       placeholder=""
            />
            <div class="error" v-if="!$v.unEmployment.start_date.isValidFromDate">
              From Date Can't Be Greater Than To Date.
            </div>
            <label class="col-sm-12 mb-sm-0">Unemployment End Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="unEmployment.end_date"
                       placeholder=""
            />
            <label class="col-sm-12 mb-sm-0">Please upload proof document for Unemployment.</label>
            <upload-btn :fileObj="unEmployment.files"
                        :renderType="type.CandidateDetail"
                        :emailAddress="emailAddress"
            />
          </div>
        </template>
        <template v-if="employment_type === historyType.Others">
          <history-others
              :othersObject="others"
              :emailAddress="emailAddress"
          />
        </template>

      <div class="row mb-sm-2">
        <div class="col-sm-12">
          <el-button class="btn el-button--success"
                     @click="() => addBtnHandler()">
           Save And Add Another {{ getValueById(employment_type) }}
          </el-button>
        </div>
      </div>
      <!--    <pre>{{ $v }}</pre>-->
      <template v-if="is_modal">
        <app-modal
            :modal-id="modalId"
            modal-alignment="top"
            modal-size="fullscreen"
            @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">{{ $t("History Update") }}</h5>
            <button
                type="button"
                class="close outline-none"
                data-dismiss="modal"
                aria-label="Close"
            >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
            </button>
          </template>
          <template slot="body">
            <div class="card card-with-search border-0 card-with-shadow">
              <template v-if="employment_type === historyType.Employment">
                <div class="form-group mb-3 col-md-6 align-items-center">
                  <label class="col-sm-12 mb-2">Do you have other employment?</label>
                  <app-input class="col-sm-12"
                             type="radio"
                             :list="yesOrNoList"
                             v-model="employment.is_other_employment"/>
                </div>
                <template v-if="employment.is_other_employment === 'yes'">
                  <div class="form-group mb-3 col-md-12 align-items-center">
                    <label class="col-sm-12 mb-2">
                      Would you continue other employment, if you were successful in obtaining
                      employment with us?
                    </label>
                    <app-input class="col-sm-12"
                               type="text"
                               @keyup="(event) => textOnChange(event, 'continue_other_employment', validationType.Alphabet)"
                               v-model="employment.continue_other_employment"
                               placeholder=""
                    />
                  </div>
                </template>
                <div class="form-group mb-3 col-md-6 align-items-center">
                  <label class="col-sm-12 mb-sm-2">Provide previous employment details. Do you have p45 or p46</label>
                  <app-input class="col-sm-12"
                             type="radio"
                             :list="employmentDetailsTypeList"
                             v-model="employment.is_have_p45_or_p46"
                             placeholder=""
                  />
                </div>
                <template v-if="employment.is_have_p45_or_p46 === 'p45'">
                  <div class="form-group mb-3 col-md-6 align-items-center">
                    <label class="col-sm-12 mb-2">Attach a copy of P45</label>
                    <app-input class="col-sm-12"
                               type="file"
                               v-on:change="documentp45Change"
                               :label="$t('upload_your_file')"
                               v-model="employment.copy_of_p45"
                               placeholder="attach copy"
                    />
                  </div>
                </template>
                <template v-if="employment.is_have_p45_or_p46 === 'p46'">
                  <div class="form-group mb-3 mt-3 col-md-6 align-items-center">
                    <app-input class="col-sm-12 mb-sm-4"
                               type="radio"
                               :list="p46List"
                               v-model="employment.p46_detail"
                               placeholder=""
                    />
                  </div>
                </template>
                <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Job Title</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="employment.title"
                             placeholder=""
                  />
                </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Job Description</label>
                  <app-input class="col-sm-12 mr-sm-2 mb-sm-2"
                             type="textarea"
                             v-model="employment.description"
                             placeholder=""
                  />
                  </div>

                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Company Name</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="employment.company_name"
                             placeholder=""
                  />
                    </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Address</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="employment.company_address"
                             placeholder=""
                  />
                      </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Reason for Leaving</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="employment.reason_for_leaving"
                             placeholder=""
                  />
                        </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Contact Name</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="employment.contact_name"
                             placeholder=""
                  />
                          </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Contact Number</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="tel-input-custom"
                             v-model="employment.contact_number"
                             placeholder=""
                  />
                            </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Contact Email</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="email"
                             v-model="employment.contact_email"
                             placeholder=""
                  />
                  </div>
                  <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Employment Start Date</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="employment.start_date"
                             placeholder=""
                  />
                  </div>

                  <div class="form-group row align-items-center ml-sm-2">
                  <div class="error" v-if="!$v.employment.start_date.isValidFromDate">
                    From Date Can't Be Greater Than To Date.
                  </div>
                  <label class="col-sm-12 mb-sm-0">Employment End Date</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="employment.end_date"
                             placeholder=""
                  />
                </div>
              </template>
              <template v-if="employment_type === historyType.Education">
                <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Qualification</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="education.qualification"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Institute</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="education.institute"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Award Date</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="education.award_date"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Course Length</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="education.course_length"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Contact Name</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="education.contact_name"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Contact Number</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="tel-input-custom"
                             v-model="education.contact_number"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Contact Email</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="email"
                             v-model="education.contact_email"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Institute Address</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="textarea"
                             v-model="education.institute_address"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">From</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="education.start_date"
                             placeholder=""
                  />
                  <div class="error" v-if="!$v.education.start_date.isValidFromDate">
                    From Date Can't Be Greater Than To Date.
                  </div>
                  <label class="col-sm-12 mb-sm-0">To</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="education.end_date"
                             placeholder=""
                  />
                </div>
              </template>
              <template v-if="employment_type === historyType.SelfEmploymentTrade">
                <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Trading Name / Business Name</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="selfEmployment.name"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">UTR / Company Number</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="selfEmployment.utr_number"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Trading / Business Details</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="textarea"
                             v-model="selfEmployment.details"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Trading / Business Address</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="selfEmployment.address"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Accountant Name</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="text"
                             v-model="selfEmployment.accountant_name"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Accounting Firm</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="textarea"
                             v-model="selfEmployment.accounting_firm"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Contact Number</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="tel-input-custom"
                             v-model="selfEmployment.contact_number"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Contact Email</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="email"
                             v-model="selfEmployment.contact_email"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">From</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="selfEmployment.start_date"
                             placeholder=""
                  />
                  <div class="error" v-if="!$v.selfEmployment.start_date.isValidFromDate">
                    From Date Can't Be Greater Than To Date.
                  </div>
                  <label class="col-sm-12 mb-sm-0">To</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="selfEmployment.end_date"
                             placeholder=""
                  />
                </div>
              </template>
              <template v-if="employment_type === historyType.Unemployed">
                <div class="form-group row align-items-center ml-sm-2">
                  <label class="col-sm-12 mb-sm-0">Unemployment Start Date</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="unEmployment.start_date"
                             placeholder=""
                  />
                  <div class="error" v-if="!$v.unEmployment.start_date.isValidFromDate">
                    From Date Can't Be Greater Than To Date.
                  </div>
                  <label class="col-sm-12 mb-sm-0">Unemployment End Date</label>
                  <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                             type="date"
                             v-model="unEmployment.end_date"
                             placeholder=""
                  />
                  <label class="col-sm-12 mb-sm-0">Please upload proof document for Unemployment.</label>
                </div>
              </template>
              <template v-if="employment_type === historyType.Others">
                <history-others :othersObject="others"/>
              </template>
            </div>
          </template>

          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="updateModal"
            >
              {{ $t("Update") }}
            </button>
            <button
                type="button"
                class="btn btn-primary mr-2"
                data-dismiss="modal"
                @click="closeModal"
            >
              {{ $t("Close") }}
            </button>
          </template>
        </app-modal>
      </template>
    </form>
  </div>
</template>

<script>
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {required} from 'vuelidate/lib/validators'
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {
  calculateDifference,
  calculateDifferenceInDays, getHighlightClass,
  getHighlightStyle, getLatestStatus,
  getStatusComment, getStatusValue, isRevertToApplicant
} from "@Views/Screening/utility/common";
import {
  _statusColors,
  employmentDetailsTypeList,
  employmentTypeList,
  p46List,
  siaLicenseTypeList,
  visaTypeList
} from "@Views/Screening/utility/constant";
import {_yesOrNoList} from "@Views/Screening/utility/constant";
import {historyType, uploadBtnRenderType} from "@Views/Screening/utility/enums";
import {File} from "@Views/Screening/utility/apiAgent";

export default {
  name: "CandidateHistory",
  mixins: [FormMixin, ModalMixin],
  props: {
    candidate_history_info: {
      type: Array,
    },
    dateFormatter: {
      type: Function,
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    onSaveBtn: Function,

  },
  data() {
    return {
      siaLicenseTypeList: siaLicenseTypeList,
      licenseOptions: siaLicenseTypeList,
      visaTypeList: visaTypeList,
      employmentDetailsTypeList: employmentDetailsTypeList,
      p46List: p46List,
      employment: {},
      education: {},
      selfEmployment: {},
      unEmployment: {},
      others: {},
      employment_type: '',
      index: 0,
      resolvedStatuses: {}, // Object to store statuses by ID
      statusLinks: {}, // Object to store links by ID
      yesOrNoList: _yesOrNoList,
      modalId: "history_modal",
      is_modal: false,
      employmentTypeList: employmentTypeList,
      error: {
        isError: false,
        errorMessage: ''
      },
      historyType: historyType,
      type: uploadBtnRenderType,
      statusColors: _statusColors,
    };
    
  },
  methods: {
    getHighlightStyle,
    getStatusComment,
    getLatestStatus,
    getStatusValue,
    isRevertToApplicant,
    getHighlightClass,
    closeModal(){
      this.resetFormState()
      this.is_modal = false

    },
    textOnChange(event, model, validationType) {
      const text = event?.target.value;
      if (text) {
        if (validationType === this.validationType.AlphaNumeric16Characters) {
          this.validation[model] = this.validateAlphaNumericSixteenCharacter(text);
        }else if (validationType === this.validationType.AlphaNumeric) {
          this.validation[model] = this.validateAlphaNumeric(text);
        }else if (validationType === this.validationType.Alphabet) {
          this.validation[model] = this.validateAlphabet(text);
        }else if (validationType === this.validationType.Numeric) {
          this.validation[model] = this.validateNumeric(text);
        }else if (validationType === this.validationType.Email) {
          this.validation[model] = this.validateEmail(text);
        }
        if(!this.validation[model]){
          // this.basic_info[field] = text.slice(0, -1);
          this.$set(this.basic_info, model, text.slice(0, -1));
          // event.preventDefault();
        }
        this.$set(this.validation, model, this.validation[model]);
      }
    },
    calculateDifferenceInDays,
    calculateDifference,
    resetFormState(){
      this.employment = {};
      this.unEmployment = {};
      this.selfEmployment = {};
      this.education = {};
      this.others = {};
    },
    addBtnHandler() {
      if (this.employment_type === 'employment') {
        // if (!this.$v.$invalid) {
        if (!this.calculateDifferenceInDays(this.employment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info.push({...this.employment, type: 0});
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.employment = {};
        // }

        return;
      }
      if (this.employment_type === 'education') {
        // if (!this.$v.$invalid) {
        if (!this.calculateDifferenceInDays(this.education.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info.push({...this.education, type: 1});
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.education = {};
        // }
        return;
      }
      if (this.employment_type === 'selfEmploymentTrade') {
        // if (!this.$v.$invalid) {
        if (!this.calculateDifferenceInDays(this.selfEmployment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info.push({...this.selfEmployment, type: 2});
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.selfEmployment = {};
        // }
        return;
      }
      if (this.employment_type === 'unemployed') {
        // if (!this.$v.$invalid) {
        if (!this.calculateDifferenceInDays(this.unEmployment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info.push({...this.unEmployment, type: 3});
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.unEmployment = {};
        // }
        return;
      }
      if (this.employment_type === 'others') {
        // if (!this.$v.$invalid) {
        if (!this.calculateDifferenceInDays(this.others.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info.push({...this.others, type: 3});
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.unEmployment = {};
        // }
        return;
      }
      this.$toastr.i('Select History First.');
    },
    updateBtnHandler(id, type) {
      const target = this.candidate_history_info.find(item => item.id === id && item.type === type); // Match both id and type
      if (!target) {
        console.error('No matching record found for the given ID and type');
        return; // Handle the case where no match is found
      }

      if (type === 0) {
        this.employment = target;
        this.employment_type = 'employment';
      }
      if (type === 1) {
        this.education = target;
        this.employment_type = 'education';
      }
      if (type === 2) {
        this.selfEmployment = target;
        this.employment_type = 'selfEmploymentTrade';
      }
      if (type === 3) {
        this.unEmployment = target;
        this.employment_type = 'unemployed';
      }

      this.index = this.candidate_history_info.findIndex(item => item.id === id && item.type === type); // Optionally store the index
      this.is_modal = true;
    },

    removeBtnHandler(id, type) {
      const itemIndex = this.candidate_history_info.findIndex(item => item.id === id && item.type === type);

      if (itemIndex !== -1) {
        this.candidate_history_info.splice(itemIndex, 1); // Remove the item at the found index
       // this.$toastr.s('History removed, ');
      } else {
        console.error(`No matching record found for id: ${id} and type: ${type}`);
      }
    },

    documentp45Change() {
      this.uploadBtnHandler(this.employment.copy_of_p45, 'p45_document');
    },
    //todo
    //duplicate function, need refactoring
    uploadBtnHandler(_file, _type, _issueDate = null, _expiryDate = null) {
      let data = {email: this.emailAddress, type: _type, files: _file};
      if (_issueDate){
        data.issue_date = _issueDate
      }
      if (_expiryDate){
        data._expiryDate = _issueDate
      }
      let formData = new FormData;
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      File.uploadDocument(formData)
          .then((response) => {
            this.employment.copy_of_p45 = response.data[0]?.file_path
            this.$toastr.s(response.data.message);
          })
          .catch(({error}) => {
            //trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    async fetchStatus(screening_endorsement_id) {
      try {
        // If link already exists, open it directly
        if (this.statusLinks[screening_endorsement_id]) {
          window.open(this.statusLinks[screening_endorsement_id], "_blank");
          return;
        }

        // Fetch the link if not available
        const response = await fetch(`/screening-endorsement/link/${screening_endorsement_id}`);
        let data = await response.text(); // Get response as text

        // Update the status and link for the specific ID
        this.$set(this.resolvedStatuses, screening_endorsement_id, data);
        this.$set(this.statusLinks, screening_endorsement_id, data);

        // Open the link after fetching
        window.open(data, "_blank");
      } catch (error) {
        console.error("Error fetching status:", error);
        this.$set(this.resolvedStatuses, screening_endorsement_id, "Error fetching status");
      }
    }
    ,
    updateModal() {
      if (this.employment_type === 'employment') {
        this.employment = this.candidate_history_info[this.index];
        if (!this.calculateDifferenceInDays(this.employment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info[this.index] = this.employment;
      }
      if (this.employment_type === 'education') {
        this.education = this.candidate_history_info[this.index];
        if (!this.calculateDifferenceInDays(this.education.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info[this.index] = this.education;
      }
      if (this.employment_type === 'selfEmploymentTrade') {
        this.selfEmployment = this.candidate_history_info[this.index];
        if (!this.calculateDifferenceInDays(this.selfEmployment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info[this.index] = this.selfEmployment;
      }
      if (this.employment_type === 'unemployed') {
        this.unEmployment = this.candidate_history_info[this.index];
        if (!this.calculateDifferenceInDays(this.unEmployment.start_date)) {
          this.$toastr.e('Difference of start date should not be greater than 28 days with previous entry.');
          return;
        }
        this.candidate_history_info[this.index] = this.unEmployment;
      }
      this.employment = {}
      this.is_modal = false;
    },
    getValueById(id = null) {
      if(!id) return;
      // Find the object with the id "selfEmploymentTrade"
      const result = this.employmentTypeList.find(
        (item) => item.id === id
      );
      // Set the value property
      return result.value;
    },
    },

  validations: {
    employment: {
      start_date: {
        required,
        isValidFromDate(value) {
          if (value && (value < this.employment.end_date)) {
            return true;
          }
          return false;
        }
      },
    },
    education: {
      start_date: {
        required,
        isValidFromDate(value) {
          if (value && (value < this.education.end_date)) {
            return true;
          }
          return false;
        }
      },
    },
    selfEmployment: {
      start_date: {
        required,
        isValidFromDate(value) {
          if (value && (value < this.selfEmployment.end_date)) {
            return true;
          }
          return false;
        }
      },
    },
    unEmployment: {
      start_date: {
        required,
        isValidFromDate(value) {
          if (value && (value < this.unEmployment.end_date)) {
            return true;
          }
          return false;
        }
      },
    }
  },
  mounted() {
    this.getValueById(); // Call the method when the component is mounted
    // this.fetchStatus()
  },
  computed: {
    latestStatus() {
      // Get the latest screening status
      return this.getLatestScreeningStatus(item.screening_status);
    },
    latestStatusColorAndValue() {
      // Get the color and value for the latest status
      return this.getStatusColorAndValue(this.latestStatus?.status);
    },
    sortedCandidateHistory(){
      return [...this.candidate_history_info].sort((a, b) => new Date(b.end_date) - new Date(a.end_date));
    },

    historyGaps() {
      let gaps = [];
      const fiveYearsAgo = new Date();
      fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

      let today = new Date();
      let gracePeriodEnd = new Date();
      gracePeriodEnd.setDate(gracePeriodEnd.getDate() - 40); // 40-day grace period

      // Sort history by end_date (latest first)
      let sortedHistory = [...this.candidate_history_info].sort(
          (a, b) => new Date(b.end_date) - new Date(a.end_date)
      );

      let previousEndDate = today; // Start checking from today

      // 🔥 **Check missing period from 5 years ago**
      if (sortedHistory.length === 0 || new Date(sortedHistory[sortedHistory.length - 1].start_date) > fiveYearsAgo) {
        gaps.push({
          start: fiveYearsAgo,
          end: sortedHistory.length > 0 ? new Date(sortedHistory[sortedHistory.length - 1].start_date) : today,
        });
      }

      sortedHistory.forEach((history, index) => {
        const currentStartDate = new Date(history.start_date);
        const currentEndDate = history.end_date ? new Date(history.end_date) : today;

        // Ignore histories before 5 years ago
        if (currentEndDate < fiveYearsAgo) return;

        // 🔥 **Detect gaps between history entries**
        if (currentStartDate > previousEndDate) {
          gaps.push({
            start: previousEndDate,
            end: new Date(currentStartDate),
            days: Math.round((currentStartDate - previousEndDate) / (1000 * 60 * 60 * 24)), // Calculate days
          });
        }

        // Update previousEndDate
        previousEndDate = currentEndDate > previousEndDate ? currentEndDate : previousEndDate;
      });

      // 🔥 **Check gap from last recorded history to today (if not in grace period)**
      if (previousEndDate < gracePeriodEnd) {
        gaps.push({
          start: previousEndDate,
          end: today,
          days: Math.round((today - previousEndDate) / (1000 * 60 * 60 * 24)),
        });
      }

      return gaps;
    }

  },
  watch:{

  },

}
</script>